import React, { useContext, useEffect, useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { Button, makeStyles } from '@material-ui/core';
import { FcGoogle } from 'react-icons/fc';
import { urlConfig } from '../../config/urlConfig';
import {
  accessTokenRequest,
  sendRequest,
} from '../../services/global/global.service';
import { ProfileContext } from '../../services/profile/profile.context';

const useStyle = makeStyles((theme) => {
  return {
    Button: {
      display: 'flex',
      justifyContent: 'start',
      marginRight: 16,
      marginTop: 16,
    },
  };
});

export const ConnectAccountGoogle = ({ setError }) => {
  const classes = useStyle();
  const [loading, setLoading] = useState(false);
  const [isConnect, setIsConnect] = useState(false);
  const { user, checkIsConnect } = useContext(ProfileContext);

  useEffect(() => {
    const userData = {
      provider: 'google',
      user_uuid: user && user.uid,
    };

    user && user.uid && checkIsConnect(setLoading, setIsConnect, userData);
  }, [user]);

  const connectAccount = useGoogleLogin({
    onSuccess: async (TokenResponse) => {
      responseGoogle(TokenResponse);
    },
  });

  const disconnectGoogle = () => {
    setLoading(true);

    const userData = {
      user_uuid: user.uid,
      provider: 'google',
    };

    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.disconnect, response, 'post', userData)
          .then((res) => {
            setIsConnect(false);
            setLoading(false);
          })
          .catch((e) => {
            setLoading(false);
          });
      })
      .catch((e) => setLoading(false));
  };

  const responseGoogle = (response) => {
    setLoading(true);

    axios
      .get('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: { Authorization: `Bearer ${response.access_token}` },
      })
      .then((googleResult) => {
        if (googleResult.data && googleResult.data.email) {
          axios
            .post(urlConfig.connect_account, {
              uid: googleResult.data.sub,
              user_uuid: user.uid,
              provider: 'google',
            })
            .then((result) => {
              if (result.status !== 204) {
                setIsConnect(true);
                setLoading(false);
                setError('');
              } else {
                setLoading(false);
                setError(
                  'This Account has already been connected!'
                );
              }
            })
            .catch((err) => {
              setIsConnect(false);
              setLoading(false);
              setError(err.toString());
            });
        }
      });
    setLoading(false);
  };

  return (
    <Button
      disabled={loading}
      onClick={isConnect ? disconnectGoogle : connectAccount}
      variant='outlined'
      className={classes.Button}
      startIcon={<FcGoogle className={classes.googleIcon} />}
    >
      {isConnect ? 'Disconnect Google' : 'Connect Google'}
    </Button>
  );
};
